import React, { useState, useRef, useEffect } from "react";
import { Card } from "primereact/card";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Messages } from "primereact/messages";
import autenticacaoService from "../services/autenticacaoService";
import { hideProcessing, showProcessing } from "../utils/utils";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { useTheme } from "../contexts/ThemeContext";
import "../styles/Login.css";

export default function ResetarSenha() {
    const [novaSenha, setNovaSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState("");
    const [tokenValido, setTokenValido] = useState(true);
    const msgRef = useRef();
    const { theme } = useTheme();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tokenParam = params.get("token");
        
        if (!tokenParam) {
            setTokenValido(false);
            msgRef.current.show({
                closable: false,
                severity: "error",
                summary: "Erro",
                detail: "Token não fornecido. Link inválido.",
            });
        } else {
            setToken(tokenParam);
        }
    }, []);

    const logoSrc = theme === 'dark' 
        ? require("../images/logo-dark.png") 
        : require("../images/logo.png");

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleFormSubmit(e);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        
        if (!novaSenha || !confirmarSenha) {
            msgRef.current.show({
                closable: false,
                severity: "warn",
                summary: "Aviso",
                detail: "Por favor, preencha todos os campos",
            });
            return;
        }

        if (novaSenha.length < 6) {
            msgRef.current.show({
                closable: false,
                severity: "warn",
                summary: "Aviso",
                detail: "A senha deve ter no mínimo 6 caracteres",
            });
            return;
        }

        if (novaSenha !== confirmarSenha) {
            msgRef.current.show({
                closable: false,
                severity: "warn",
                summary: "Aviso",
                detail: "As senhas não conferem",
            });
            return;
        }

        setLoading(true);
        showProcessing();

        try {
            const response = await autenticacaoService.resetarSenha(token, novaSenha);

            if (response.status === 200) {
                msgRef.current.show({
                    closable: false,
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Senha redefinida com sucesso! Redirecionando para login...",
                });

                setTimeout(() => {
                    hideProcessing();
                    setLoading(false);
                    window.location.href = "/entrar";
                }, 2000);
            }
        } catch (e) {
            hideProcessing();
            setLoading(false);

            msgRef.current.show({
                closable: false,
                severity: "error",
                summary: "Erro",
                detail: e.response?.data || "Erro ao redefinir senha",
            });
        }
    };

    if (!tokenValido) {
        return (
            <div className="login-container">
                <div className="login-theme-switcher">
                    <ThemeSwitcher />
                </div>
                <div className="login-wrapper">
                    <Messages ref={msgRef} className="login-messages" />
                    
                    <Card className="login-card">
                        <div className="login-header">
                            <img src={logoSrc} alt="WGSol Logo" className="login-logo" style={{ width: "80%", borderRadius: "13px" }} />
                            <p className="login-subtitle">Gestão de Obras</p>
                        </div>
                        <div style={{ textAlign: "center", marginTop: "2rem" }}>
                            <p>Token inválido. <a href="/entrar">Voltar ao login</a></p>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-theme-switcher">
                <ThemeSwitcher />
            </div>
            <div className="login-wrapper">
                <Messages ref={msgRef} className="login-messages" />
                
                <Card className="login-card">
                    <div className="login-header">
                        <img src={logoSrc} alt="WGSol Logo" className="login-logo" style={{ width: "80%", borderRadius: "13px" }} />
                        <p className="login-subtitle">Redefinir Senha</p>
                    </div>

                    <form onSubmit={handleFormSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="novaSenha" className="form-label">
                                Nova Senha
                            </label>
                            <Password
                                id="novaSenha"
                                value={novaSenha}
                                onChange={(e) => setNovaSenha(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder={"Digite sua nova senha"}
                                inputClassName="form-input"
                                disabled={loading}
                                toggleMask
                                weakLabel="Fraca"
                                mediumLabel="Média"
                                strongLabel="Forte"
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmarSenha" className="form-label">
                                Confirmar Senha
                            </label>
                            <Password
                                id="confirmarSenha"
                                value={confirmarSenha}
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder={"Confirme sua nova senha"}
                                inputClassName="form-input"
                                disabled={loading}
                                toggleMask
                                feedback={false}
                            />
                        </div>

                        <Button
                            type="submit"
                            label={"Redefinir Senha"}
                            className="login-button"
                            loading={loading}
                            disabled={loading || !novaSenha || !confirmarSenha}
                            icon="pi pi-check"
                            iconPos="right"
                        />
                    </form>

                    <div style={{ textAlign: "center", marginTop: "1rem" }}>
                        <a href="/entrar">Voltar ao login</a>
                    </div>
                </Card>

                <div className="login-footer">
                    <p className="footer-text">
                        © 2026 WGSol. Todos os direitos reservados.
                    </p>
                </div>
            </div>
        </div>
    );
}
